// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qm-9";
export var arrowButtonContainer = "_qm-5";
export var arrowButtonIcon = "_qm-6";
export var carouselArrowButton = "_qm-2";
export var carouselElementContainer = "_qm-1";
export var currentSlide = "_qm-8";
export var left = "_qm-3";
export var otherSlide = "_qm-a";
export var productCarouselContainer = "_qm-0";
export var right = "_qm-4";
export var sliderOverflow = "_qm-7";